import firebase from 'firebase'

export default {
  actions: {
    createUser({ commit }, user) {
      commit("clearError");
      commit("setLoading", true);

      // const newUser = {
      //   name: user.name,
      //   phone: user.phone,
      //   email: user.email,
      //   password: user.password
      // };

      return new Promise((resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
          .then((user) => {
            console.log('user:', user)
            resolve(user)
          })
          .catch(err => {
            commit('setError', err)
            reject(err)
          })
          .finally(() => commit('setLoading', false))
      })
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user/index.js